import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import NewPaymentMethodForm from './NewPaymentMethodForm';

export interface PaymentMethodPanelProps {
  open: boolean;
  onClose: () => void;
  onSave: (values: FormNewPaymentMethod | undefined) => void;
  isLoading: boolean;
}

const PaymentMethodPanel: React.FC<PaymentMethodPanelProps> = ({
  open,
  onClose,
  onSave,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer isOpen={open} onClose={onClose}>
      <DrawerOverlay>
        <DrawerContent>
          <DrawerCloseButton data-testid="payment-method-panel-close-button" />
          <DrawerHeader>{t('new_payment_method.title')}</DrawerHeader>
          <DrawerBody padding="1.5rem">
            <NewPaymentMethodForm onSubmit={onSave} />
          </DrawerBody>
          <DrawerFooter>
            <Button
              form="new-payment-method-form"
              isLoading={isLoading}
              type="submit"
              width="100%"
            >
              {t('titles.save')}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};

export default PaymentMethodPanel;
